import { Link, createFileRoute, useRouterState } from '@tanstack/react-router'
import { ModelEvaluationPage } from '@/features/model-registry'

// `models_`: under the Models address without being rendered inside the Models page.
export const Route = createFileRoute('/app/model-registry/models_/$modelId/evaluation')({
  component: ModelEvaluationRoute,
})

function ModelEvaluationRoute() {
  const { modelId } = Route.useParams()
  // Absent after a reload or when the address was opened directly: the list then has its defaults.
  const listSearch = useRouterState({ select: (state) => state.location.state.modelList }) ?? {}

  return (
    <ModelEvaluationPage
      // A new model starts on Overview with nothing read: its own state, not the previous one's.
      key={modelId}
      modelId={modelId}
      renderModelsLink={(content, className) => (
        <Link to="/app/model-registry/models" search={listSearch} className={className}>
          {content}
        </Link>
      )}
      renderModelLink={(id, content, className) => (
        <Link
          to="/app/model-registry/models/$modelId/evaluation"
          params={{ modelId: id }}
          state={{ modelList: listSearch }}
          className={className}
        >
          {content}
        </Link>
      )}
      renderOtherLink={(content, className) => (
        <Link
          to="/app/model-registry/models/$modelId/experiment"
          params={{ modelId }}
          // The list state travels on, so the Models tab still returns to it.
          state={{ modelList: listSearch }}
          className={className}
        >
          {content}
        </Link>
      )}
    />
  )
}
